import { render, staticRenderFns } from "./DynamicThermometer.vue?vue&type=template&id=473b8b6e"
import script from "./DynamicThermometer.vue?vue&type=script&lang=js"
export * from "./DynamicThermometer.vue?vue&type=script&lang=js"
import style0 from "./DynamicThermometer.vue?vue&type=style&index=0&id=473b8b6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports